
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 25,
  viewBox: "0 0 20 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v25H0z"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#i-icon_401ae8b8d2779195__pnyvrjrbub)",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 25a.566.566 0 0 1-.318-.1c-3.91-2.63-6.39-4.43-7.848-7.235C.3 14.688 0 10.675 0 4.75c0-.237.14-.452.355-.55L9.766.046A.495.495 0 0 1 9.943 0h.072a.486.486 0 0 1 .219.046L19.656 4.2a.594.594 0 0 1 .344.55c0 5.925-.3 9.938-1.834 12.92-1.467 2.822-3.944 4.616-7.848 7.235A.563.563 0 0 1 10 25zm.005-23.763L1.188 5.129c.023 6.387.48 9.637 1.688 11.993 1.3 2.507 3.669 4.225 7.129 6.56 3.465-2.345 5.834-4.068 7.118-6.56 1.22-2.357 1.677-5.607 1.688-11.993l-8.806-3.892z",
  stroke: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.006 15.181a1.487 1.487 0 1 0 0 2.974 1.487 1.487 0 0 0 0-2.974zm0-8.923a1.485 1.485 0 0 0-1.48 1.487l.3 5.358a1.184 1.184 0 0 0 1.18 1.192 1.182 1.182 0 0 0 1.167-1.192l.3-5.358a1.483 1.483 0 0 0-1.467-1.487z"
})))));

      const __svgRaw = "<svg width=\"20\" height=\"25\" viewBox=\"0 0 20 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <defs>\r\n        <path id=\"lym4v3wlma\" d=\"M0 0h20v25H0z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M0 0h20v25H0z\"/>\r\n        <g>\r\n            <g mask=\"url(#pnyvrjrbub)\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n                <path d=\"M10 25a.566.566 0 0 1-.318-.1c-3.91-2.63-6.39-4.43-7.848-7.235C.3 14.688 0 10.675 0 4.75c0-.237.14-.452.355-.55L9.766.046A.495.495 0 0 1 9.943 0h.072a.486.486 0 0 1 .219.046L19.656 4.2a.594.594 0 0 1 .344.55c0 5.925-.3 9.938-1.834 12.92-1.467 2.822-3.944 4.616-7.848 7.235A.563.563 0 0 1 10 25zm.005-23.763L1.188 5.129c.023 6.387.48 9.637 1.688 11.993 1.3 2.507 3.669 4.225 7.129 6.56 3.465-2.345 5.834-4.068 7.118-6.56 1.22-2.357 1.677-5.607 1.688-11.993l-8.806-3.892z\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n                <path d=\"M10.006 15.181a1.487 1.487 0 1 0 0 2.974 1.487 1.487 0 0 0 0-2.974zM10.006 6.258a1.485 1.485 0 0 0-1.48 1.487l.3 5.358a1.184 1.184 0 0 0 1.18 1.192 1.182 1.182 0 0 0 1.167-1.192l.3-5.358a1.483 1.483 0 0 0-1.467-1.487z\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/i-icon.401ae8b8d2779195d04ac810840049b3.svg"),
        {
          React: SvgIIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      